import { takeLatest, call, put } from "redux-saga/effects";
import { saveNewChatOnMongoDb } from "../../api/saveNewChatOnMongoDb";
import { getActiveSocket } from "../../config/globalSocket";
import {
  createNewGroup,
  getInitialChats,
  groupInfoUpdateSuccessfull,
  initGroupInfoUpdate,
  newChatSuccessfullyCreated,
  newGroupCreated,
  onChatsLoadComplete,
  sendMsgStart,
  setActiveChat,
} from "../reducers/chat";
import store from "../store";
import { globalAxios } from "../../config/globalAxios";

// Fetch initial chat data
const getInitialChatData = async () => {
  const { data } = await globalAxios({
    method: "GET",
    url: `/chats`,
    withCredentials: true,
  });
  return data.data;
};

// Fetch all messages for chats
const getAllMessages = async (data) => {
  return await Promise.all(
    data.map(async (obj) => {
      const res = await globalAxios({
        method: "GET",
        url: `/chats/${obj._id}`,
        withCredentials: true,
      });
      console.log(res);
      return [obj, res.data.data];
    })
  );
};

// Load initial chats
export function* initChatLoad() {
  yield takeLatest(getInitialChats.type, function* () {
    const _all = yield call(getInitialChatData);
    const chats = yield call(getAllMessages, _all);
    const chatsObj = chats.reduce((result, item) => {
      result[item[0]._id] = {
        chatInfo: item[0],
        messages: item[1],
      };
      return result;
    }, {});
    yield put(onChatsLoadComplete(chatsObj));
  });
}

// Send message saga
export function* initSendMsgStart() {
  yield takeLatest(sendMsgStart.type, function* (action) {
    const socket = yield call(getActiveSocket);

    if (action.payload.clientSide) {
      delete action.payload.clientSide;
      const status = yield call(
        saveNewChatOnMongoDb,
        store.getState()?.chatState.chat[action.payload.refId],
        "/create-new-chat"
      );
      if (status === 200) {
        yield put(newChatSuccessfullyCreated(action.payload.refId));
        socket.emit("updateOthersChats", {
          chatInfo: {
            ...store.getState().chatState.chat[action.payload.refId].chatInfo,
          },
          messages: [],
        });
        socket.emit("iTextMessage", {
          ...action.payload,
        });
      }
    } else {
      socket.emit("iTextMessage", action.payload);
    }
  });
}

// Switch active chat
export function* activeChatSwitch() {
  yield takeLatest(setActiveChat.type, function* (action) {
    // Placeholder for socket action on active chat switch
  });
}

// Handle group creation
export function* handleGroupCreation() {
  yield takeLatest(createNewGroup.type, function* (action) {
    const status = yield call(
      saveNewChatOnMongoDb,
      store.getState().chatState.chat[action.payload._id],
      "/create-new-group"
    );
    const socket = yield call(getActiveSocket);
    if (status === 200) {
      socket.emit("updateOthersChats", {
        chatInfo: action.payload,
        messages: [],
      });
      yield put(newGroupCreated(action.payload._id));
    }
  });
}

// Update group info
export function* initGroupInfoUpdateSaga() {
  yield takeLatest(initGroupInfoUpdate.type, function* (action) {
    const socket = getActiveSocket();
    yield socket.emit("updateGroupInfo", action.payload);
    yield put(groupInfoUpdateSuccessfull(action.payload));
  });
}
